import { useState, useEffect } from 'react';
import { supabaseGetter } from '~/api/supabase-getter';

/**
 * Hook to fetch all crop templates
 * @returns {Object} Crop templates, loading state, and error
 */
export const useCropTemplates = ({ collectionCodes }) => {
  const [cropTemplates, setCropTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);

      try {
        const { data: templateData, error: templateError } =
          await supabaseGetter.cropTemplates.getByCollections(collectionCodes);

        if (templateError) throw templateError;

        setCropTemplates(templateData || []);
      } catch (err) {
        console.error('Error fetching crop templates:', err);
        setError(err.message);
        setCropTemplates([]);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [collectionCodes]);

  return {
    cropTemplates,
    loading,
    error,
    invalidate: () => {
      supabaseGetter.cropTemplates.invalidate();
    }
  };
}
